import { escapeRegExp } from 'lodash';

export function includesIgnoreCase(haystack: string, needle: string): boolean {
  const regex = new RegExp(escapeRegExp(needle), 'i');
  return regex.test(haystack);
}
